import React from 'react';
import dayJS from 'dayjs';
import styled from 'styled-components';
import { device } from '../../theme';
import { useStaticQuery, graphql } from 'gatsby';
import AWLogo from '../../assets/svgs/logo.svg';
const StyledFooter = styled.footer`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;

const StyledFooterBy = styled.div`
  text-align: right;
  align-items: center;
  justify-content: flex-end;
  display: inline-flex;
  @media ${device.tablet} {
    justify-content: center;
  }
`;

const StyledCopyright = styled.div`
  @media ${device.tablet} {
    text-align: center;
  }
`;

const StyledAWLogo = styled(AWLogo)`
  width: 32px;
  color: ${({ theme }) => theme.primary};
`;

const Footer = () => {
  const siteInfo = useStaticQuery(
    graphql`
      query storiFooterTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
        storiThemeData {
          basePath
          siteTitle
        }
      }
    `
  );
  const { title } = siteInfo.site.siteMetadata;
  const { basePath, siteTitle } = siteInfo.storiThemeData;

  return (
    <StyledFooter>
      <StyledCopyright>
        &copy; {dayJS().format('YYYY')} {siteTitle ? siteTitle : title}
      </StyledCopyright>
      <StyledFooterBy>
        <StyledAWLogo />
        <span>
          Designed and Coded by{' '}
          <a href="https://www.adamwebster.me" rel="noopener">
            Adam Webster
          </a>
        </span>
      </StyledFooterBy>
    </StyledFooter>
  );
};

export default Footer;
